
    import { Component } from 'vue-property-decorator';
    import Util from '@/lib/util';
    import ListBase from '@/lib/listbase';
    import PageRequest from '@/store/entities/page-request';
    import ListView from '@/components/helper/list-view.vue';
    import FormBase from '@/components/helper/form-base.vue';
    import AgreementForm from './agreement-form.vue';
    import ChartLevels from './chart-levels.vue';
    import ChartStatuses from './chart-statuses.vue';

    class PageAgreementRequest extends PageRequest {
        year: any = parseInt(new Date().toISOString().substr(0, 4));
        dealer: number = null;
        manufacturer: number = null;
        zone: number = 1;
    }

    @Component({
        components: { ListView, AgreementForm, FormBase, ChartLevels, ChartStatuses },
        watch: {
            dealer: function (val) {
                (this as any).pagerequest.dealer = val;
                (this as any).getpage();
            },
            manufacturer: function (val) {
                (this as any).pagerequest.manufacturer = val;
                (this as any).getpage();
            }
        }
    })
    export default class Agreements extends ListBase {
        entity: string = 'agreement';
        pagerequest: PageAgreementRequest = new PageAgreementRequest();
        filterForm: boolean = true;
        showDealers: boolean = false;
        widType: string = 'Venta';
        views: Array<any> = [{ code: "stats", title: "Ver Estadisticas", icon: "bar_chart" }];
        currentView: string = 'list';

        filterItems = [
            this.gItem({ type: 'object', prop: 'zone', label: 'Zona', entity: 'zone', size: 3, hideDetails: true, onchange: this.changeZone }),
            this.gItem({ type: 'object', prop: 'dealer', label: 'Concesionario', entity: 'dealer', itemText: 'fullname', hideDetails: true, size: 3, filterParam: 'zone_id', filterVal: [this.pagerequest.zone], onchange: this.getpage }),
            this.gItem({ type: 'object', prop: 'manufacturer', label: 'Marca', entity: 'manufacturer', hideDetails: true, size: 3, onchange: this.getpage }),
            this.gItem({ type: 'select', prop: 'year', label: 'Anio', options: 'years', hideDetails: true, onchange: this.getpage, size: 3 }),
        ]

        columns = [
            this.gCol('dealer.fullname', 'Concesionario', 'text'),
            this.gColO({ type: 'text', value: 'reason', text: 'Punto a tratar' }),
            this.gCol('description', 'Descripcion', 'text'),
            this.gColO({ type: 'list', value: 'employees_names', text: 'Responsables' }),
            this.gCol('agreement_date', 'Fecha firma del acuerdo', 'date'),
            this.gCol('days', 'Plazo (en dias)', 'text'),
            this.gCol('due_date', 'Fecha de venc', 'date'),
            this.gCol('days_remain', 'Dias restantes', 'text'),
            this.gColO({ type: 'chip', value: 'state_calc', text: 'Estado', color: 'extra', generalType: true }),
            this.gColO({ type: 'chip', value: 'level_id', text: 'Nivel de cumplimiento', color: 'extra', generalType: true }),
            this.defaultActions()
        ]

        get title() {
            let zone = Util.getEntity(this, 'zone', this.pagerequest.zone);
            return 'Seguimiento de Protocolos' + (zone != null ? ' - '  + zone.name : '');
        }

        get dealer() {
            return this.$store.state.app.dealer;
        }
        get manufacturer() {
            return this.$store.state.app.manufacturer;
        }

        get loading() {
            return this.$store.state.agreement.loading;
        }

        get isDealer() {
            return Util.abp.session.isDealer();
        }

        edit() {
            this.modalShow = !this.modalShow;
        }
        create() {
            this.modalShow = !this.modalShow;
        }

        changeZone(id) {
            this.setItem(this.filterItems, 'dealer', 'filterVal', [id]);
            this.getpage();
        }

        async getpage() {
            let list: any = this.$refs.listView
            if (list != undefined)
                await list.getpage();

            if (this.$refs.lev != undefined)
                await (this.$refs.lev as any).loadData();

            if (this.$refs.sta != undefined)
                await (this.$refs.sta as any).loadData();
        }

        async sendNoty() {
            await this.$store.dispatch({
                type: 'agreement/sendNoty'
            });
        }

        mounted() {
            this.setItem(this.filterItems, 'zone', 'disabled', this.isDealer);
            this.setItem(this.filterItems, 'dealer', 'disabled', this.isDealer);
        }

        created() {
            this.pagerequest.dealer = this.dealer;
            let deal = Util.getEntity(this, 'dealer', this.dealer);

            if (deal != null)
                this.pagerequest.zone = deal.zone_id;
        }
    }
